import { isSuited, tileNumber, NUM_TILE_TYPES, Tile } from './tiles';
import { TileCounts } from './hand';

export type GroupType = 'shuntsu' | 'koutsu' | 'pair';

export interface Group {
  type: GroupType;
  tile: Tile; // shuntsu: 가장 낮은 패, koutsu/pair: 해당 패
}

export interface StandardParse {
  groups: Group[];
}

/** 표준형(4면자+1작두)의 가능한 모든 분해를 열거한다. 완성형이 아니면 빈 배열. */
export function decomposeStandard(counts: TileCounts): StandardParse[] {
  const results: StandardParse[] = [];
  const c = counts.slice();

  for (let p = 0; p < NUM_TILE_TYPES; p++) {
    if (c[p] >= 2) {
      c[p] -= 2;
      collectMelds(c, 0, [], results, p);
      c[p] += 2;
    }
  }
  return dedupe(results);
}

function collectMelds(
  c: number[],
  start: number,
  melds: Group[],
  results: StandardParse[],
  pairTile: Tile,
): void {
  let idx = start;
  while (idx < NUM_TILE_TYPES && c[idx] === 0) idx++;
  if (idx === NUM_TILE_TYPES) {
    results.push({ groups: [...melds, { type: 'pair', tile: pairTile }] });
    return;
  }

  // 커쯔(刻子)
  if (c[idx] >= 3) {
    c[idx] -= 3;
    melds.push({ type: 'koutsu', tile: idx });
    collectMelds(c, idx, melds, results, pairTile);
    melds.pop();
    c[idx] += 3;
  }
  // 슌쯔(順子)
  if (isSuited(idx) && tileNumber(idx) <= 7 && c[idx + 1] > 0 && c[idx + 2] > 0) {
    c[idx]--; c[idx + 1]--; c[idx + 2]--;
    melds.push({ type: 'shuntsu', tile: idx });
    collectMelds(c, idx, melds, results, pairTile);
    melds.pop();
    c[idx]++; c[idx + 1]++; c[idx + 2]++;
  }
  // 둘 다 못 만들면 이 경로는 막다른 길 (push 없이 반환)
}

function keyOf(p: StandardParse): string {
  return p.groups
    .map((g) => `${g.type}:${g.tile}`)
    .sort()
    .join('|');
}

function dedupe(parses: StandardParse[]): StandardParse[] {
  const seen = new Set<string>();
  const out: StandardParse[] = [];
  for (const p of parses) {
    const k = keyOf(p);
    if (!seen.has(k)) { seen.add(k); out.push(p); }
  }
  return out;
}
